module.exports = __webpack_public_path__ + "img/pdf-template.e4fa4959.jpg";